// The one definition of a Super Admin ("OpCo admin" in the code). Shown on the
// Super Admins panel, in the confirm dialog before granting the role, and in the
// Users Guide, so the three can't drift apart. Each line matches a route that is
// guarded by is_opco_admin() on the server.
export const SUPER_ADMIN_CAPABILITIES = [
  'See every OpCo and the All OpCos view, not only the ones they belong to',
  'Create, rename, deactivate and import OpCos',
  'Add and remove members in any OpCo, and set their roles',
  'Set up Auto-assign rules and place existing people',
  'Manage each OpCo’s domains, mailboxes, NetSuite and Business Central connections',
  'Grant or remove the Admin role, and move templates between OpCos',
  'See organisation-wide billing, retention and audit views',
  'Add or remove other Super Admins',
]

export const SUPER_ADMIN_CONDITIONS = [
  'Super Admin only applies when OpCo workspaces are switched on.',
  'The person needs an account here and the Admin role. Without the Admin role the rights stay inactive.',
  'People listed in the deployment settings are permanent and can only be changed by whoever deploys the app.',
]

const BOX = 'rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-800/30 px-4 py-3'

export default function SuperAdminDefinition({ compact = false, className = '' }) {
  return (
    <div className={`${BOX} ${className}`} data-testid="super-admin-definition">
      {!compact && (
        <>
          <p className="text-xs font-semibold text-gray-900 dark:text-gray-100">
            A Super Admin runs OpCos for the whole organisation, not just one.
          </p>
          <p className="mt-2 text-xs font-medium text-gray-600 dark:text-gray-400">A Super Admin can:</p>
        </>
      )}
      <ul className={`${compact ? '' : 'mt-1 '}list-disc space-y-0.5 pl-5 text-xs text-gray-600 dark:text-gray-400`}>
        {SUPER_ADMIN_CAPABILITIES.map((c) => <li key={c}>{c}</li>)}
      </ul>
      {!compact && (
        <>
          <p className="mt-3 text-xs text-gray-600 dark:text-gray-400">
            <span className="font-medium">How it differs:</span> a regular Admin (set in Users) only manages the OpCos they belong to,
            and an OpCo manager only looks after the members of their own OpCo.
          </p>
          <ul className="mt-2 list-disc space-y-0.5 pl-5 text-xs text-gray-500 dark:text-gray-400">
            {SUPER_ADMIN_CONDITIONS.map((c) => <li key={c}>{c}</li>)}
          </ul>
        </>
      )}
    </div>
  )
}
